import moment from 'moment';

const FormDatePicker = ({ onChange, value, children, required }) => {
  return (
    <div className="registerDate__wrapper">
      <input
        required={required}
        className="form__registerDate"
        name="DTCadastro"
        type="date"
        onChange={onChange}
        value={value}
        max={moment().format('YYYY-MM-DD')}
      />
      <label className="register__label">{children}</label>
    </div>
  );
};

export default FormDatePicker;
